import React, { useCallback, useRef } from 'react';
import { View } from 'react-native';
import { Typography } from '@hmsexp/component-library';
import LowerSampleSizeFooter from '../../LowerSampleSizeFooter';
import useTransformNPSData from './hooks/useTransformNPSData';
import styles from './style';
import MultiFeatureCard from '../../Card/MultiOptionsCard/MultiFeatureCard';
import PieChartContainer from './PieChartContainer';
import EmojiMap from '../../EmojiMap';
import { handleHighChartsExport } from '../../../../containers/Overview/utils';

const NetPromoterScoreWidget = ({ item, timeperiodLabel,actionMenuData=[], onChartClick }) => {

    const {
        npsSubtitle,
        isNpsLowSampleSize,
        npsLowSampleSize,
        options,
        npsDataObj
    } = useTransformNPSData(item, timeperiodLabel);
    const chartRef = useRef(null);
    const pieChartTooltip = useCallback((scoreSize, label) => {
        return (
            <View style={styles.pieChartContainer}>
                <Typography textProps={{ style: styles.tooltipValue }} variant='button' color='white'>
                    {scoreSize}
                </Typography>
                <Typography textProps={{ style: styles.tooltipLabel }} variant='button' color='white'>
                    {label || timeperiodLabel}
                </Typography>
            </View>
        );
    }, [timeperiodLabel]);

    function actionButtonClick(e) {
        handleHighChartsExport(e, chartRef, item);
    }

    const renderContent = (activeSwitch) => (
        <View style={{ flexDirection: 'row', justifyContent: 'center', gap: 20, alignItems: 'center', flex: 1 }}>
            <View>
                <PieChartContainer
                    isLowSampleSize={isNpsLowSampleSize}
                    tooltipComponent={() => pieChartTooltip(options?.centerLabel?.subLabel)}
                    data={item}
                    options={options}
                    onChartClick={e => onChartClick(e, { ...item, subTitle: npsSubtitle })}
                    activeSwitch={activeSwitch}
                    ref={chartRef}
                />
            </View>
            <View style={{ gap: 10 }}>
                <View style={{ flexDirection: 'row', gap: 10, alignItems: 'center' }}>
                    <EmojiMap type='HAPPY' color='#88909F' backgroundColor='#F5F6F7' />
                    <Typography variant='button' fontWeightType='regular'>
                        {npsDataObj?.promoter_percentage}% ({npsDataObj?.promoter_count})
                    </Typography>
                </View>
                <View style={{ flexDirection: 'row', gap: 10, alignItems: 'center' }}>
                    <EmojiMap type='NEUTRAL' color='#88909F' backgroundColor='#F5F6F7' />
                    <Typography variant='button' fontWeightType='regular'>
                        {npsDataObj?.passive_percentage}% ({npsDataObj?.passive_count})
                    </Typography>
                </View>
                <View style={{ flexDirection: 'row', gap: 10, alignItems: 'center' }}>
                    <EmojiMap type='SAD' color='#88909F' backgroundColor='#F5F6F7' />
                    <Typography variant='button' fontWeightType='regular'>
                        {npsDataObj?.detractor_percentage}% ({npsDataObj?.detractor_count})
                    </Typography>
                </View>
            </View>
        </View>
    );

    return (
        <MultiFeatureCard
            title={item?.title}
            subTitle={npsSubtitle}
            actionMenu={actionMenuData}
            renderContent={renderContent}
            onActionButtonClick={actionButtonClick}
            enableActionBtn={true}
            style={{ childContainer: { paddingVertical: 20, paddingTop: 40 } }}
            enableSwitchTab={item?.enableSwitchTab}
            switchOptions={item?.switchOptions}
            renderFooter={() => (
                <View>
                    {isNpsLowSampleSize && <LowerSampleSizeFooter size={npsLowSampleSize} />}
                    <Typography fontWeightType='regular' variant='button'>
                        {item?.footerText}
                    </Typography>
                </View>
            )}
        />
    );
};

export default NetPromoterScoreWidget;